<div class="servicerequest-container" class="csp1">
  <mat-card>
    <mat-tab-group>
      <div *ngIf="servicetab">
      <mat-tab label="Service request">
        <div fxLayout="row" class="csp2">
          <div fxFlex="6"  fxFlex.lt-md="10" fxFlex.lt-sm="15" fxFlex.xs="20" class="csp3">
            <img src="./assets/images/responsive_icon.png" class="csp4" alt="">
          </div>
          <div fxFlex="94"  fxFlex.lt-md="90" fxFlex.lt-sm="85" fxFlex.xs="80" fxLayoutAlign="center center">
            <p fxFlex class="csp5">For any service request, provide us the details and we will respond at earliest.</p>
          </div>
        </div>

        <form class="serviceform csp6" #servicerequestform="ngForm"
          (ngSubmit)="onSubmit(servicerequestform.value, 'servicerequest')">
          <div fxLayout="column" fxLayoutGap="15px">
            <div *ngIf="nisusadd">
              <mat-form-field appearance="outline" class="csp7">
                <mat-label>Select Request Name</mat-label>
                <mat-select placeholder="Select User Rights" name=Rightsupdate>
                    <mat-option *ngFor="let ob of Cond" [value]="ob.value">
                        {{ob.value}}</mat-option>
                </mat-select>
                <!-- <mat-hint class="error-clr" *ngIf="Rightsupdate">User Rights is required</mat-hint> -->
            </mat-form-field>
              </div>
            <div>
              <div fxLayout="row">
                <mat-form-field appearance="outline" class="csp7" fxFlex="100">
                  <mat-label>Service request</mat-label>
                  <textarea matInput maxlength="1000" class="csp8"
                  placeholder="Your Message Here..."
                    [(ngModel)]="servicerequesttext" name="servicerequesttext">
                  </textarea>
                </mat-form-field>
              </div>
            </div>

            <div>
              <div class="csp7" fxFlex="100" fxLayoutAlign="center center">
                <button type="button" class="csp9" mat-button (click)="servicerequestchoosefile.click()">Choose
                  File</button>
                <span class="csp10">{{servicerequestfilename}}</span>

                <input #servicerequestchoosefile class="csp11" type="file" name="requestuploadfile"
                 (change)="onFileChange($event, 'servicerequest')"
                  accept="application/pdf, image/*" >
              </div>
            </div>

            <div>
              <div fxLayout="row" fxLayoutAlign="center center">
                <button type="submit" class="csp12" mat-button>SUBMIT YOUR FEEDBACK</button>
              </div>
            </div>
          </div>
        </form>
        <div>
          <p class="csp13">If you have any question or need help resolving a problem, you can also reach out to our customer support at
           <span class="csp14">{{mail_id}}</span></p>
        </div>
      </mat-tab>
    </div>
      <mat-tab label="Query">
        <div fxLayout="row" class="csp2">
          <div fxFlex="6" fxFlex.lt-md="10" fxFlex.lt-sm="15" fxFlex.xs="20" class="csp3">
            <img src="./assets/images/responsive_icon.png" class="csp4" alt="">
          </div>
          <div fxFlex="94" fxFlex.lt-md="90" fxFlex.lt-sm="85" fxFlex.xs="80" fxLayoutAlign="center center">
            <p fxFlex class="csp5">For assistance on any query, please share the details and we will reach out to you at earliest.</p>
          </div>
        </div>

        <form class="serviceform csp6" #queryform="ngForm"
          (ngSubmit)="onSubmit(queryform.value, 'query')">
          <div fxLayout="column" fxLayoutGap="15px">
            <div *ngIf="nisusadd">
              <mat-form-field appearance="outline" class="csp7">
         <mat-label>Query Name</mat-label>
         <mat-select placeholder="Select User Rights" name=Rightsupdate
            >
             <mat-option *ngFor="let ob of Cond" [value]="ob.value">
                 {{ob.value}}</mat-option>
         </mat-select>
         <!-- <mat-hint class="error-clr" *ngIf="Rightsupdate">User Rights is required</mat-hint> -->
     </mat-form-field>
       </div>
            <div>
              <div fxLayout="row">
                <mat-form-field appearance="outline" class="csp7" fxFlex="100">
                  <mat-label>Query</mat-label>
                  <textarea matInput maxlength="1000" class="csp8" placeholder="Your Message Here..."
                    [(ngModel)]="querytext" name="querytext">
                             </textarea>
                </mat-form-field>
              </div>
            </div>

            <div>
              <div class="csp7" fxFlex="100" fxLayoutAlign="center center">
                <button type="button" class="csp9" mat-button (click)="querychoosefile.click()">Choose
                  File</button>
                <span class="csp10">
                  {{queryfilename}}
                </span>

                <input #querychoosefile class="csp11" type="file" name="queryuploadfile"
                 (change)="onFileChange($event, 'query')"
                  accept="application/pdf, image/*" >
              </div>
            </div>

            <div>
              <div fxLayout="row" fxLayoutAlign="center center">
                <button type="submit" class="csp12" mat-button>SUBMIT YOUR FEEDBACK</button>
              </div>
            </div>
          </div>
        </form>
        <div>
          <p class="csp13">If you have any question or need help resolving a problem, you can also reach out to our customer support at <span class="csp14">{{mail_id}}</span></p>
        </div>
      </mat-tab>
      <div *ngIf="complainttab">
      <mat-tab label="Complaint">
        <div class="csp2" fxLayout="row">
          <div fxFlex="6" fxFlex.lt-md="10" fxFlex.lt-sm="15" fxFlex.xs="20" class="csp3">
            <img src="./assets/images/responsive_icon.png" class="csp4" alt="">
          </div>
          <div fxFlex="94" fxFlex.lt-md="90" fxFlex.lt-sm="85" fxFlex.xs="80" fxLayoutAlign="center center">
            <p fxFlex class="csp5">Give us the detail about any problems you are having. We will investigate the issue.</p>
          </div>
        </div>

        <form class="csp6" class="serviceform" #complaintform="ngForm"
          (ngSubmit)="onSubmit(complaintform.value, 'complaint')">
          <div fxLayout="column" fxLayoutGap="15px">
            <div>
              <div fxLayout="row">
                <mat-form-field appearance="outline" class="csp7" fxFlex="100">
                  <mat-label>Complaint</mat-label>
                  <textarea matInput maxlength="5000" class="csp8" placeholder="Your Message Here..."
                    [(ngModel)]="complainttext" name="complainttext">
                             </textarea>
                </mat-form-field>
              </div>
            </div>

            <div>
              <div class="csp7" fxFlex="100" fxLayoutAlign="center center">
                <button type="button" class="csp9" mat-button (click)="complaintchoosefile.click()">Choose
                  File</button>
                <span class="csp10">
                  {{complaintfilename}}
                </span>

                <input #complaintchoosefile class="csp11" type="file" name="complaintuploadfile"
                 (change)="onFileChange($event, 'complaint')"
                  accept="application/pdf, image/*" >
              </div>
            </div>

            <div>
              <div fxLayout="row" fxLayoutAlign="center center">
                <button type="submit" class="csp12" mat-button>SUBMIT YOUR FEEDBACK</button>
              </div>
            </div>
          </div>
        </form>
        <div>
          <p class="csp13">If you have any question or need help resolving a problem, you can also reach out to our customer support at <span class="csp14">{{mail_id}}</span></p>
        </div>
      </mat-tab>
    </div>
    </mat-tab-group>
  </mat-card>
</div>